module.exports = __webpack_public_path__ + "static/media/dashboard-welcome-student.a4303b27.svg";